/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_No_TracksInputs */



/**
* | output |
* | --- |
* | "No caption tracks with text were found in this file." |
*
* @param {Subtitle_Extract_No_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_no_tracks = /** @type {((inputs?: Subtitle_Extract_No_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_No_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune piste de sous-titres avec du texte n'a été trouvée dans ce fichier.")
	if (locale === "de") return /** @type {LocalizedString} */ ("In dieser Datei wurden keine Untertitelspuren mit Text gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("In questo file non sono state trovate tracce di sottotitoli con testo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В этом файле не обнаружено текстовых субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron pistas de subtítulos con texto en este archivo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此文件中未找到带文本的字幕轨道。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このファイルには、テキストを含む字幕トラックは見つかりませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस फाइल में टेक्स्ट वाले कोई कैप्शन ट्रैक नहीं मिले।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foram encontradas legendas com texto neste arquivo.")
	return /** @type {LocalizedString} */ ("No caption tracks with text were found in this file.")
});